import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Grid,
  CssBaseline,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  TextField,Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import HelpIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import { tokens } from "../../../theme/theme";
import { useTheme } from "@mui/material/styles";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import CallAlertBar from "../../../Layout/Alertbar";
import AddUpdateWarehouseEnvironment from "./AddUpdateWarehouseEnvironment";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import { moduleHelpData } from "../../../data/moduleHelpData";
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";

const WarehouseEnvironmentIndex = ({ handleBackWinderMachineEntry }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [anchorElFirst, setAnchorElFirst] = useState(null);
  const [anchorElSecond, setAnchorElSecond] = useState(null);
  const [selectedOptionFirst, setSelectedOptionFirst] = useState("All Environment Types");
  const openFirst = Boolean(anchorElFirst);
  const openSecond = Boolean(anchorElSecond);

  const [envList, setEnvList] = useState([]);
  const [filteredEnvList, setFilteredEnvList] = useState([]);
  const [filters, setFilters] = useState({
    code: "",
    description: "",
    status: "",
  });

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [envFormData, setEnvFormData] = useState({});

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  
  const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

const userPermissions = useUserPermissions();
  // ---- Menu Handlers ----
  const handleMenuClickFirst = (event) => setAnchorElFirst(event.currentTarget);
  const handleMenuCloseFirst = () => setAnchorElFirst(null);

  const handleMenuItemClickFirst = (option) => {
    setSelectedOptionFirst(option);
    setAnchorElFirst(null);
  };

  const handleMenuClickSecond = (event) => setAnchorElSecond(event.currentTarget);
  const handleMenuCloseSecond = () => setAnchorElSecond(null);
  const handleMenuItemClickSecond = (option) => {
    console.log("Selected secondary:", option);
    setAnchorElSecond(null);
  };

  // ---- Load List ----
  const LoadEnvironmentList = () => {
    const payload = {
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
    };
    callApi(
      Warehouse_API_ENDPOINTS.environmentType.list,
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setEnvList(data);
          setFilteredEnvList(data);
        } else {
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No environment data found!");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Failed to load environment data");
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    LoadEnvironmentList();
  }, []);

  // ---- Filter & Menu Logic ----
  // useEffect(() => {
  //   let filtered = envList.filter((row) => {
  //     const statusText = row.status === true ? "active" : "inactive";

  //     // Apply text field filters
  //     const matchesCode = row.code
  //       ?.toLowerCase()
  //       .includes(filters.code.toLowerCase());
  //     const matchesDesc = row.description
  //       ?.toLowerCase()
  //       .includes(filters.description.toLowerCase());
  //     const matchesStatus = statusText
  //       .toLowerCase()
  //       .includes(filters.status.toLowerCase());

  //     // Apply menu selection
  //     if (selectedOptionFirst === "Active Environment Types" && !row.status)
  //       return false;
  //     if (selectedOptionFirst === "InActive Environment Types" && row.status)
  //       return false;

  //     return matchesCode && matchesDesc && matchesStatus;
  //   });

  //   setFilteredEnvList(filtered);
  // }, [filters, envList, selectedOptionFirst]);
useEffect(() => {
  const filtered = (envList || []).filter((row) => {
    // ✅ Normalize status from boolean or string → "active"/"inactive"
    const statusText =
      row.status === true ||
      (typeof row.status === "string" &&
        row.status.toLowerCase() === "active")
        ? "active"
        : "inactive";

    // ✅ Normalize filter inputs to lowercase
    const fCode = (filters.code || "").toLowerCase();
    const fDesc = (filters.description || "").toLowerCase();
    const fStatus = (filters.status || "").toLowerCase();

    // ✅ Match filters
    const matchesCode = (row.code || "").toLowerCase().includes(fCode);
    const matchesDesc = (row.description || "")
      .toLowerCase()
      .includes(fDesc);
    const matchesStatus = statusText.startsWith(fStatus);

    // ✅ Apply menu selection (Active / Inactive)
    if (
      selectedOptionFirst === "Active Environment Types" &&
      statusText !== "active"
    )
      return false;

    if (
      selectedOptionFirst === "InActive Environment Types" &&
      statusText !== "inactive"
    )
      return false;

    return matchesCode && matchesDesc && matchesStatus;
  });

  setFilteredEnvList(filtered);
}, [filters, envList, selectedOptionFirst]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddNew = () => {
    setEnvFormData({});
    setIsFormOpen(true);
  };

  const handleEdit = (row) => {
    setEnvFormData(row);
    setIsFormOpen(true);
  };
const handleExit = () => {
    handleBackWinderMachineEntry();
  };
  return (
    <Box>
      <CssBaseline />

      {!isFormOpen && (
        <>
          {/* Top Toolbar */}
          <AppBar
            position="static"
            sx={{
              backgroundColor: "inherit",
              borderRadius: "0px",
              height: "48px",
              justifyContent: "center",
            }}
          >
            <Toolbar>
              {/* Filter Menu */}
          <Box >
            <Button
              color="secondary"
              onClick={handleMenuClickFirst}
              endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
              sx={{ textTransform: "none", fontSize: "16px", fontWeight: 500 }}
            >
              {selectedOptionFirst}
            </Button>
            <Menu
              anchorEl={anchorElFirst}
              open={openFirst}
              onClose={handleMenuCloseFirst}
            >
              <MenuItem onClick={() => handleMenuItemClickFirst("All Environment Types")}>
                All Environment Types
              </MenuItem>
              <MenuItem
                onClick={() => handleMenuItemClickFirst("Active Environment Types")}
              >
                Active Environment Types
              </MenuItem>
              <MenuItem
                onClick={() => handleMenuItemClickFirst("InActive Environment Types")}
              >
                InActive Environment Types
              </MenuItem>
            </Menu>
          </Box>
              
{hasPermission(userPermissions, "Warehouse environment type", "Create") && (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<AddIcon sx={{ fontSize: "18px" }} />}
                sx={{ marginLeft: "auto", textTransform: "none" }}
                onClick={handleAddNew}
              >
                New Environment
              </Button>
)}
              <IconButton size="small" sx={{ ml: 2 }} onClick={handleMenuClickSecond}>
                <MoreVertIcon sx={{ fontSize: "18px" }} />
              </IconButton>
              <Menu
                anchorEl={anchorElSecond}
                open={openSecond}
                onClose={handleMenuCloseSecond}
              >
                <MenuItem onClick={() => handleMenuItemClickSecond("Import")}>
                  <ImportExportIcon fontSize="small" />
                  &nbsp;Import Environment
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClickSecond("Export")}>
                  <FileDownloadIcon fontSize="small" />
                  &nbsp;Export Environment
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleMenuItemClickSecond("Refresh")}>
                  <RefreshIcon fontSize="small" />
                  &nbsp;Refresh List
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleMenuItemClickSecond("Reset Columns")}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<FormatAlignJustifyIcon />}
                  >
                    Reset Columns Width
                  </Button>
                </MenuItem>
              </Menu>

              {/* <IconButton size="small" sx={{ ml: 1 }}>
                <HelpIcon sx={{ fontSize: "18px" }} />
              </IconButton> */}

                <Tooltip title="View help document details" arrow>
                <IconButton
                  size="small"
                  aria-label="help"
                  sx={{ mx: 1 }}
                  onClick={handleHelpMenuClick}
                >
                  <HelpIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
              
              
                                      <ModuleHelpDialog
                                          open={helpOpen}
                                          onClose={handleCloseHelp}
                                          data={moduleHelpData.WarehouseEnvironmentTypeMaster}
                                      />

              <IconButton size="small" onClick={handleExit}>
                <CloseIcon sx={{ fontSize: "18px", color: "#2196F3" }} />
              </IconButton>
            </Toolbar>
          </AppBar>

         

          {/* Alert */}
          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          {/* Table */}
          <Grid container padding={1} spacing={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  "& .MuiTableCell-root": {
                    border: "1px solid",
                    borderColor: `${colors.primary[400]} !important`,
                    padding: "4px",
                    fontSize: "13px",
                  },
                  maxHeight: "75vh",
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { width: "8px" },
                  "&::-webkit-scrollbar-thumb": {
                    background: colors.blueAccent[600],
                    borderRadius: "10px",
                  },
                }}
              >
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>ENVIRONMENT CODE</TableCell>
                        <TableCell>DESCRIPTION</TableCell>
                        <TableCell>STATUS</TableCell>
                      </TableRow>
                      {/* Column-wise filter row */}
                      <TableRow>
                        <TableCell>
                          <TextField
                            name="code"
                            value={filters.code}
                            onChange={handleFilterChange}
                            size="small"
                            variant="outlined"
                            fullWidth
                            placeholder="Filter code"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            name="description"
                            value={filters.description}
                            onChange={handleFilterChange}
                            size="small"
                            variant="outlined"
                            fullWidth
                            placeholder="Filter description"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            name="status"
                            value={filters.status}
                            onChange={handleFilterChange}
                            size="small"
                            variant="outlined"
                            fullWidth
                            placeholder="Filter status"
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredEnvList.map((row) => (
                        <TableRow key={row.environment_type_id}>
                          <TableCell
                            sx={{
                              color: "teal",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handleEdit(row)}
                          >
                            {row.code}
                          </TableCell>
                          <TableCell>{row.description}</TableCell>
                          <TableCell>
                            {row.status === true ? "Active" : "Inactive"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {isFormOpen && (
        <AddUpdateWarehouseEnvironment
          envFormData={envFormData}
          setEnvFormData={setEnvFormData}
          setIsFormOpen={setIsFormOpen}
          LoadEnvironmentList={LoadEnvironmentList}
        />
      )}
    </Box>
  );
};

export default WarehouseEnvironmentIndex;
